import { types, getParent, getParentOfType } from 'mobx-state-tree';
import OrderProperty from './OrderProperty';
import Order from "./Order";

export default types.model('OrderLine', {
    OrderLineId: types.identifierNumber,
    Sku: types.string,
    VariantSku: types.maybeNull(types.string),
    Name: types.string,
    ProductName: types.string,
    VariantName: types.maybeNull(types.string),
    Properties: types.optional(types.array(OrderProperty), []),
    Quantity: types.maybeNull(types.number),

    Price: types.number,
    UnitDiscount: types.number,
    PriceFormatted: types.string,
    ListPriceFormatted: types.string,

    PriceExFormatted: types.string,
    ListPriceExFormatted: types.string,


    PriceTotalFormatted: types.string, // Before discount

    DiscountFormatted: types.string,

    VAT: types.number,
    VATFormatted: types.string,
    
    TotalExFormatted: types.string,

    Total: types.number,
    TotalFormatted: types.string

}).views(self => ({
    get Order() {
        return getParentOfType(self, Order);
    },

    PropertyByKey(key) {
        return self.Properties.find(op => op.Key === key);
    },

    PropertyValueByKey(key) {
        const p = self.PropertyByKey(key);
        const value = p && p.Value;
        //console.debug("OrderPropertyByKey updated:", key, "Value: ", value);
        if (value) {
            return value;
        } else {
            return null;
        }
    },

    get IsGenerated() {
        return !!self.PropertyValueByKey("_generated");
    },

    get ProductUrl() {
        return self.PropertyValueByKey("_productUrl");
    },

    get PrimaryImageUrl() {
        return self.PropertyValueByKey("_primaryImageUrl");
    },

    get Color() {
        return self.PropertyValueByKey("$color");
    },

    get Size() {
        return self.PropertyValueByKey("$size");
    },
    get OriginalQuantity() {
        return parseInt(self.PropertyValueByKey("originalQuantity")) || 0;
    },

    get QuantityDiff() {

        //if (!self.Quantit) return 0;
        return (self.OriginalQuantity || 0) - (self.Quantity || 0);
    }
    //get ProductName() {
    //    if (!self.VariantSku) {
    //        return self.Name;
    //    } else {
    //        const productNameArray = self.Name.split("|");
    //        if (productNameArray.length > 1) {
    //            return productNameArray[0];
    //        } else {
    //            return self.Name;
    //        }
    //    }
    //},

    //get VariantName() {
    //    if (self.VariantSku) {
    //        const productNameArray = self.Name.split("|");
    //        if (productNameArray.length > 1) {
    //            return productNameArray[1];
    //        } else {
    //            return self.Name;
    //        }
    //    }
    //}



    //,
    //get ModelName() {
    //	const op = self.OrderProperties.find(x => x.Key === "ModelName");
    //	return (op ? op.Value : "");
    //}
})).actions(self => ({
    SetQuantity(value) {
        self.Quantity = value;
    },

    SetOriginalQuantity(value) {
        var p = self.PropertyByKey("originalQuantity");
        if (!p) {
            self.Properties.push({ OrderPropertyId: "", Key: "originalQuantity", Value: "" + value });

            //const c = self.OriginalQuantity;
            //console.log("originalQuantity", c);
        } else {
            p.Value = "" + value;
        }
    },
    SetPropertyValueByKey(key, value) {
        const p = self.PropertyByKey(key);
        if (p) {
            p.Value = "" + value;
        } else {
            self.Properties.push({ OrderPropertyId: "", Key: key, Value: "" + value });
        }
    }
}));
